import { HTMLProps, forwardRef } from 'react';

import {
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      alignItems: 'center',
      marginBottom: theme.spacing(3),
      gridTemplateColumns: '1fr max-content',
      gridColumnGap: theme.spacing(1),
    },
  });

export interface SidebarSectionHeaderProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionHeaderMui = forwardRef<
  HTMLDivElement,
  SidebarSectionHeaderProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(className, classes.root)} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionHeaderMui.displayName = 'SidebarSectionMui.Header';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarSection and delete. */
export default withStyles(styles)(SidebarSectionHeaderMui);
